import React from 'react'
import { Divider } from 'antd';

const EmbedCardTitleDivier = () => {
  return (
    <Divider className="mt-2 border-t-[1.5px] border-gray-200" />
  )
}

export default EmbedCardTitleDivier